(function () {
  'use strict';

  var REPLY_PATTERN = /\[reply:(\d+)\]/;
  var COMMENT_SELECTOR = '.article-template__comments-comment, #bloggle_comment-layout > div > article';

  var textarea = null;
  var adminMode = false;
  var pendingReplies = []; // { element, parentId } whose parent is not loaded yet, in display order

  function getComments(root) {
    return Array.prototype.slice.call(root.querySelectorAll(COMMENT_SELECTOR));
  }

  // Author name is set as text, never parsed as HTML
  function setIndicator(reply, authorName) {
    var indicator = document.createElement('div');
    indicator.className = 'comment-reply-indicator';
    if (authorName) {
      var strong = document.createElement('strong');
      strong.textContent = authorName;
      indicator.append('En réponse à ', strong);
    } else {
      indicator.textContent = 'En réponse à un commentaire';
    }

    var header = reply.element.querySelector('header');
    if (header) {
      header.insertAdjacentElement('afterend', indicator);
    } else {
      reply.element.insertBefore(indicator, reply.element.firstElementChild);
    }
  }

  // Move reply element right after the parent (or after the last existing reply of that parent).
  // Returns false when the parent is not loaded yet.
  function placeReply(reply) {
    var parentComment = document.getElementById(reply.parentId);
    if (!parentComment) return false;

    var authorEl = parentComment.querySelector('.circle-divider, .bggle--author');
    var authorName = authorEl ? authorEl.textContent.trim() : '';
    setIndicator(reply, authorName || '#' + reply.parentId);

    var insertAfter = parentComment;
    var next = parentComment.nextElementSibling;
    while (next && next.dataset.replyTo === reply.parentId && !next.hidden) {
      insertAfter = next;
      next = next.nextElementSibling;
    }
    if (insertAfter !== reply.element) {
      insertAfter.parentNode.insertBefore(reply.element, insertAfter.nextSibling);
    }
    reply.element.hidden = false;
    return true;
  }

  // Replies are flagged server-side (snippets/comment-reply.liquid). Comments
  // are listed newest first, so a reply often comes before its parent: it stays
  // hidden until « Voir plus » loads the parent, then shows under it.
  function placeReplies(comments) {
    var replies = pendingReplies.slice();
    comments.forEach(function (comment) {
      if (!comment.dataset.replyTo) return;
      comment.classList.add('comment--reply');
      replies.push({ element: comment, parentId: comment.dataset.replyTo });
    });

    pendingReplies = [];
    // Oldest first, so several replies to the same parent read chronologically
    replies.reverse().forEach(function (reply) {
      if (!placeReply(reply)) {
        reply.element.hidden = true;
        pendingReplies.unshift(reply);
      }
    });
  }

  // Nothing left to load: show the replies whose parent never came (deleted,
  // rejected in moderation…) where they are.
  function releasePendingReplies() {
    pendingReplies.forEach(function (reply) {
      setIndicator(reply, null);
      reply.element.hidden = false;
    });
    pendingReplies = [];
  }

  // Add reply buttons (admin only)
  function addReplyButtons(comments) {
    if (!adminMode || !textarea) return;

    comments.forEach(function (comment) {
      var commentId = comment.id;
      if (!commentId) return;
      if (comment.classList.contains('comment--reply')) return;

      var footer = comment.querySelector('footer');
      if (!footer || footer.querySelector('.comment-reply-btn')) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'comment-reply-btn';
      btn.innerHTML =
        '<svg class="comment-reply-btn__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="9 14 4 9 9 4"></polyline><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path></svg>' +
        '<span class="comment-reply-btn__label">Répondre</span>';
      btn.setAttribute('aria-label', 'Répondre à ce commentaire');

      btn.addEventListener('click', function () {
        var tag = '[reply:' + commentId + '] ';
        if (textarea.value.match(REPLY_PATTERN)) {
          textarea.value = textarea.value.replace(REPLY_PATTERN, '').trim();
        }
        textarea.value = tag + textarea.value;
        textarea.focus();
        textarea.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      footer.appendChild(btn);
    });
  }

  function processComments(comments) {
    placeReplies(comments);
    addReplyButtons(comments);
  }

  function byDocumentOrder(a, b) {
    return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
  }

  // « Voir plus de commentaires » : loads the next `paginate` page (light
  // main-bloggle-article-comments section) and appends it to the list, one
  // request per click.
  // Returns false when there is nothing more to load.
  function initLoadMore() {
    var button = document.querySelector('[data-comments-more]');
    var list = document.querySelector('[data-comments-list]');
    if (!button || !list || !window.fetch || !window.DOMParser) return false;
    // Landed on a later page (search result, old link…): « Voir plus » only
    // loads what comes next, so keep the classic pagination to go back.
    var page = parseInt(new URLSearchParams(window.location.search).get('page'), 10);
    if (page > 1) return false;

    var pagination = document.querySelector('[data-comments-pagination]');
    if (pagination) pagination.hidden = true;
    button.hidden = false;

    function appendPage(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newList = doc.querySelector('[data-comments-list]');
      var added = [];

      if (newList) {
        Array.prototype.slice.call(newList.children).forEach(function (comment) {
          if (comment.id && document.getElementById(comment.id)) return;
          var node = document.importNode(comment, true);
          list.appendChild(node);
          added.push(node);
        });
      }

      var nextButton = doc.querySelector('[data-comments-more]');
      var hasNext = !!(nextButton && nextButton.dataset.nextUrl);
      if (hasNext) {
        button.dataset.nextUrl = nextButton.dataset.nextUrl;
        // The fetched section has no label, only the remaining count
        var count = button.querySelector('.pdd-comments__more-count');
        var nextCount = nextButton.querySelector('.pdd-comments__more-count');
        if (count && nextCount) count.textContent = nextCount.textContent;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      } else {
        button.remove();
      }

      processComments(added);
      if (!hasNext) releasePendingReplies();

      // Replies were moved under their parent: focus the first one on screen
      var firstShown = added
        .filter(function (node) { return !node.hidden; })
        .sort(byDocumentOrder)[0];
      if (firstShown) {
        firstShown.setAttribute('tabindex', '-1');
        firstShown.focus({ preventScroll: true });
      }
    }

    button.addEventListener('click', function () {
      var url = button.dataset.nextUrl;
      if (!url || button.getAttribute('aria-busy') === 'true') return;

      button.setAttribute('aria-busy', 'true');
      button.disabled = true;

      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        // Only a failed request falls back: an error while appending the page
        // is not caught, so it is not mistaken for a network failure.
        .then(appendPage, function () {
          // Fallback: classic pagination
          button.remove();
          if (pagination) pagination.hidden = false;
          releasePendingReplies();
        });
    });

    return true;
  }

  // Shopify pagination URLs only carry ?page=, so keep reply-admin on them
  function keepAdminParamOnPagination() {
    var links = document.querySelectorAll('.pdd-comments__pagination a[href], .article-template__comments .pagination a[href]');
    Array.prototype.forEach.call(links, function (link) {
      var url = new URL(link.href, window.location.href);
      url.searchParams.set('reply-admin', '');
      link.href = url.toString();
    });
  }

  function initCommentReplies() {
    var comments = getComments(document);
    if (!comments.length) return;

    textarea = document.getElementById('CommentForm-body') || document.getElementById('bggle-comment-body');

    // Detect Shopify admin/staff browsing the storefront
    var debugMode = new URLSearchParams(window.location.search).has('reply-admin');
    adminMode = debugMode || !!(window.Shopify && Shopify.designMode);
    if (debugMode) keepAdminParamOnPagination();

    processComments(comments);
    if (!initLoadMore()) releasePendingReplies();

    if (!adminMode) {
      // Admin bar loads after page — check once DOM settles
      setTimeout(function () {
        if (document.querySelector('#admin-bar-iframe, #preview-bar-iframe, iframe[src*="admin"], shopify-preview-bar')) {
          adminMode = true;
          addReplyButtons(getComments(document));
        }
      }, 800);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCommentReplies);
  } else {
    initCommentReplies();
  }
})();
